import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import ExemptionFields from './ExemptionFields'

export const ExemptionCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <ExemptionFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default ExemptionCreate
